import { render } from "./CreateTardyDetentionCalendarForm.vue?vue&type=template&id=83930c92"
import script from "./CreateTardyDetentionCalendarForm.vue?vue&type=script&lang=js"
export * from "./CreateTardyDetentionCalendarForm.vue?vue&type=script&lang=js"

import "./CreateTardyDetentionCalendarForm.vue?vue&type=style&index=0&id=83930c92&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__